
<template>
  	<LayoutView/>
</template>

<!-- // // // //  -->

<script>

import LayoutView from './components/layout.vue'

export default {
  components: {
    LayoutView
  },
  metaInfo: {
    title: 'Users' // title is now "RCOS - Users"
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/user_list/index.vue